<template>
  <div>
    <!-- Filter & Search Input Controls -->
    <form @submit.prevent="search">
      <b-field>
        <template v-if="allowFilters">
          <p class="control mr-2">
            <button type="button" class="button is-medium" slot="trigger" size="is-medium"
              @click="showFiltersModal = true">
              <span>Filter</span>
              <b-icon icon="filter-variant"></b-icon>
            </button>
          </p>
        </template>
        <template v-if="allowSearchBy && searchByOptions.length">
          <div class="mr-1">
            <b-select id='searchBySelect' placeholder="Search by" v-model="searchByParameter" size="is-medium"
              @input="$refs.mySearchInput.focus()">
              <option v-for="searchBy in searchByOptions" :key="searchBy.value" :value="searchBy.value">
                {{ searchBy.label }}
              </option>
            </b-select>
          </div>
        </template>
        <template v-if="allowSearch">
          <b-input icon="magnify" type="search" size="is-medium" ref="mySearchInput" :placeholder="searchPlaceholder"
            :disabled="isSearchDisabled" expanded v-model="searchQuery"></b-input>
          <p class="control">
            <button type="submit" class="button is-primary is-medium">
              <b-icon icon="keyboard-return" custom-class="mdi-flip-h"></b-icon>
            </button>
          </p>
        </template>
        <template>
          <b-button v-if="hasFilters" size="is-medium" type="is-ghost" @click="clear"><span
              class="has-text-danger">Clear</span></b-button>
          <b-button v-else size="is-medium" type="is-light" :disabled="true">Clear</b-button>
        </template>
      </b-field>
    </form>
    <!-- Filter Modal -->
    <b-modal v-if="allowFilters" :active.sync="showFiltersModal" has-modal-card animation="none"
      :can-cancel="['escape', 'x']" :on-cancel="close">
      <div class="modal-card">
        <section class="modal-card-body is-paddingless">
          <!-- Instructions -->
          <p class="has-background-white-ter has-text-centered pa-sm border-b"
            :class="(hasChanges) ? 'has-text-danger' : 'has-text-grey-light'">
            {{ instructions }}
          </p>
          <!-- Filters Slot -->
          <slot></slot>
        </section>
        <footer class="modal-card-foot" style="justify-content:space-between">
          <div class="buttons is-marginless">
            <button class="button" type="button" @click="close">Close</button>
            <button class="button" type="button" @click="clear">Clear All</button>
          </div>
          <button class="button is-primary" @click="update" :disabled="!hasChanges">Update</button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showFiltersModal: false,
      searchQuery: null,
      searchByParameter: null
    }
  },
  computed: {
    instructions () {
      return (this.hasChanges)
        ? 'Click \'Update\' to apply new filters.'
        : 'Explore the filters below to target specific results.'
    },
    hasFilters () {
      if (Object.keys(this.appliedFilters.facets).length) return true
      if (Object.keys(this.appliedFilters.search).length) return true
      if (Object.keys(this.appliedFilters.timestamps).length) return true
      return false
    },
    isSearchDisabled () {
      if (this.allowSearchBy && this.searchByOptions.length && !this.searchByParameter) return true
      return false
    }
  },
  methods: {
    search () {
      if (this.allowSearchBy && this.searchByOptions.length) {
        this.$emit('search', this.searchByParameter, this.searchQuery)
      } else {
        this.$emit('search', this.searchQuery)
      }
    },
    update () {
      this.$emit('update')
      this.showFiltersModal = false
      this.$buefy.toast.open({ type: 'is-success', message: 'Filters updated!' })
    },
    close () {
      if (this.hasChanges) {
        this.$buefy.toast.open({ type: 'is-danger', message: 'Filters not applied.' })
      }
      this.showFiltersModal = false
    },
    clear () {
      this.$emit('clear')
      this.searchQuery = null
      this.searchByParameter = null
      this.showFiltersModal = false
      this.$buefy.toast.open({ type: 'is-success', message: 'Filters cleared.' })
    }
  },
  mounted () {
    if ('query' in this.appliedFilters.search && this.appliedFilters.search.query !== '') {
      this.searchQuery = this.appliedFilters.search.query
    }
    if (this.allowSearchBy && this.searchByOptions.length) {
      this.searchByParameter = this.searchByOptions[0].value
    }
  },
  props: {
    hasChanges: {
      type: Boolean
    },
    appliedFilters: {
      type: Object
    },
    allowFilters: {
      type: Boolean,
      default: true
    },
    allowSearch: {
      type: Boolean,
      default: true
    },
    searchPlaceholder: {
      type: String,
      default: 'Search within results...'
    },
    allowSearchBy: {
      type: Boolean,
      default: false
    },
    searchByOptions: {
      type: Array
    }
  }
}
</script>
